import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { apiGet } from '../../lib/api';

export default function CustomerDeliveries() {
  const [list, setList] = useState([]);
  const { selectedCustomerId, loadingProviders } = useOutletContext() || {};
  useEffect(() => {
    if (loadingProviders) return;
    const query = selectedCustomerId ? `?customer_id=${selectedCustomerId}` : '';
    apiGet(`/customer/deliveries${query}`).then(r => setList(r.data || [])).catch(() => {});
  }, [selectedCustomerId, loadingProviders]);
  return (
    <div className="space-y-3" data-testid="cust-deliveries">
      <h1 className="font-heading font-bold text-2xl text-rozops-navy">Delivery history</h1>
      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-rozops-bg border-b border-gray-100 text-xs uppercase text-rozops-text-muted font-bold">
            <tr><th className="text-left py-3 px-4">Date</th><th className="text-left py-3 px-4">Product</th><th className="text-right py-3 px-4">Qty</th><th className="text-right py-3 px-4">Amount</th><th className="text-right py-3 px-4">Status</th></tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={5} className="py-8 text-center text-rozops-text-muted">No deliveries yet.</td></tr>}
            {list.map(d => (
              <tr key={d.id} className="border-b border-gray-50 last:border-0">
                <td className="py-2 px-4">{d.delivery_date}</td>
                <td className="py-2 px-4">
                  <div>{d.product?.name}</div>
                  {d.provider?.business?.business_name && <div className="text-xs text-rozops-text-muted">{d.provider.business.business_name}</div>}
                </td>
                <td className="py-2 px-4 text-right">{d.delivered_quantity || d.planned_quantity}</td>
                <td className="py-2 px-4 text-right">₹{Number((d.delivered_quantity || d.planned_quantity) * d.price).toFixed(2)}</td>
                <td className="py-2 px-4 text-right"><span className={`text-xs font-bold ${d.status === 'delivered' ? 'text-rozops-green' : 'text-amber-600'}`}>{d.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
